import { component as defineComponent } from 'flightjs';
import trackEvent from '@99designs/utils/platform/trackEvent';

const promotedUpgrade = function() {
    this.attributes({
        dismissButton: '[data-promoted-upgrade-dismiss]',
        urlAttr: 'data-promoted-upgrade-dismiss-flag-url',
        upgradeKeyAttr: 'data-promoted-upgrade-upgrade-key',
        packageNameAttr: 'data-promoted-upgrade-package-name',
        categoryKeyAttr: 'data-promoted-upgrade-category-key',
        listingIdAttr: 'data-promoted-upgrade-listing-id',
    });

    this.after('initialize', function() {
        this.on(this.select('dismissButton'), 'click', this.dismissPromotedUpgrade);
    });

    this.dismissPromotedUpgrade = function(event) {
        const upgradeKey = this.$node.attr(this.attr.upgradeKeyAttr);

        trackEvent('Dismissed Promoted Upgrade', {
            upgrade: upgradeKey,
            listing_id: this.$node.attr(this.attr.listingIdAttr),
            package: this.$node.attr(this.attr.packageNameAttr),
            category: this.$node.attr(this.attr.categoryKeyAttr),
        });

        event.preventDefault();
        this.trigger('uiPromotedUpgradeDismiss', {
            url: this.select('dismissButton').attr(this.attr.urlAttr),
            upgradeKey: upgradeKey,
            listingId: this.$node.attr(this.attr.listingIdAttr),
        });
        this.$node.remove();
    };
};

export default defineComponent(promotedUpgrade);



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/promoted-upgrade.js